import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none'
        },
        paper: {
            padding: theme.spacing(2)
        }
    }),
);

interface Props {
    event: any;
    anchorEl: HTMLElement | null;
    onPopoverClose: () => void;
}

function ActionsListPopover(props: Props) {
    const { anchorEl, event, onPopoverClose } = props;
    const classes = useStyles({});

    const open = Boolean(anchorEl);

    return (
        <Popover
            id="mouse-over-popover"
            className={classes.popover}
            classes={{
                paper: classes.paper
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            onClose={onPopoverClose}
            disableRestoreFocus
        >
            {event && <div>
                <Typography gutterBottom>{event.approved ? 'Approved' : 'Rejected'} Actions</Typography>
                <List dense disablePadding>
                    {event.actions.map(action => (
                        <ListItem key={action} disableGutters>
                            <ListItemText primary={action} />
                        </ListItem>
                    ))}
                </List>
            </div>}
        </Popover>
    );
}

export default ActionsListPopover;
